import { takeLatest, put, call } from "redux-saga/effects";
import {
  setOccupantBegin,
  setOccupantError,
  setOccupantSuccess,
} from "./slice";
import { fetchOccupantAction, selectOccupant } from "./actions";
import { apiGet } from "api/callApi";

function* setOccupant(val) {
  yield put(setOccupantBegin());
  try {
    const data = val.payload;
    yield put(setOccupantSuccess(data));
  } catch (error) {
    yield put(setOccupantError(error));
  }
}

function* fetchOccupant(val) {
  yield put(setOccupantBegin());
  try {
    const occupantId = val.payload;

    const response = yield call(
      apiGet,
      `/v1/getoccupantdetail/${occupantId}`,
      false
    );
    yield put(setOccupantSuccess(response.data[0]));
  } catch (error) {
    yield put(setOccupantError(error));
  }
}

export function* watchsetOccupant() {
  yield takeLatest(selectOccupant.type, setOccupant);
  yield takeLatest(fetchOccupantAction.type, fetchOccupant);
}
